import type { BannerVariantType } from 'Components/shared/Banner/index.types';

/**
 * Maps the layout variant to the props `Banner` expects.
 * `default` declares `title` as required (it accepts `undefined`), so it is
 * passed explicitly without a value; `inline` does not accept a title.
 */
export const getBannerVariantProps = (
    variant: BannerVariantType
): { variant: 'inline' } | { variant: 'default'; title: undefined } =>
    variant === 'inline'
        ? { variant: 'inline' }
        : { variant: 'default', title: undefined };